import lottie from 'lottie-web';
import $ from 'jquery';
import anime from 'animejs';
import json from './trendsetter.json';
import {mouseMove, click}  from '../../listeners.js';

import products from '../../products/trendsetter.json';

class Trendsetter {
  constructor() {
    this.anim = '';
  }

  load() {
    var anim = lottie.loadAnimation({
      container: $('.trendsetter')[0],
      renderer: 'svg',
      loop: false,
      autoplay: false,
      direction: 1,
      animationData: json,
      assetsPath: 'src/images/animations/trendsetter/'
    });
    anim.addEventListener('enterFrame', (e) =>{
      if (e.currentTime == e.totalTime - 1) {
        document.addEventListener("mousemove", (e) => {
          var elements = ['tjeans', 'tshirt', 'trendsettertitle'];
          mouseMove('trendsetter', elements, e);
          elements.forEach((e) => {
            $('.' + e).css({transition: 'transform 0.2s ease-out'});
          });
        });
      }
    });

    $('.trendsetter').on('click', (e) => {
      click(products);
    });

    this.anim = anim;
    return anim;
  };

  inAnimation() {
    this.anim.setDirection(1);
    this.anim.play();
  }

  outAnimation() {
    this.anim.setDirection(-1);
    this.anim.play();
  }
}

export default new Trendsetter();
